<header class="header">
    <div class="header__title">
        <img src="https://contentdeliveryciam.blob.core.windows.net/spark/deloitte.png" alt="">
        <div class="header__label">Next Generation Deloitte Technology</div>
    </div>
    <div class="header__nav">
        <div>
            <button (click)="displayProfile()" type="button" class="reset-btn nav-btn">
                <img src="https://contentdeliveryciam.blob.core.windows.net/spark/arrow-back.svg">
            </button>
        </div>
        <div>
            <div class="profile">
                <button (click)="displayProfile()" type="button" class="reset-btn nav-btn">
                    <img src="https://contentdeliveryciam.blob.core.windows.net/spark/ic_round-search.svg">
                </button>
                <button (click)="displayProfile()" type="button" class="reset-btn nav-btn">
                    <img src="https://contentdeliveryciam.blob.core.windows.net/spark/person-outline.svg">
                    <img src="https://contentdeliveryciam.blob.core.windows.net/spark/mdi_chevron-up.svg">
                </button>
                <div class="profile__container">
                    <ng-container *ngIf="profileVisible">
                        <app-profile></app-profile>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div class="header__title_section">
        <h3>Profile management</h3>
    </div>
</header>
